<script lang="ts">
  import { tweened } from 'svelte/motion';

  export let evaluation:boolean|null = null
  export let neutral:string = "😐"
  export let positive:string = "😊"
  export let negative:string = "☹️"
  let evaluationText:string
  $: evaluationText = evaluation == null ? neutral : evaluation == true ? positive : negative

  let percent = tweened<number>(0, { duration: 500 });
  $: percent.set(evaluation === true ? 100 : evaluation === false ? -100 : 0)
  function getStyle(percent:number) {
    return `
        transform: rotate(${percent * 3.6}deg);
    `
  }
</script>

<div
  style="{getStyle($percent)}"
  class="text-center" 
>{ evaluationText }</div>
